import ConditionPage from '../components/ConditionPage';
import { CONDITIONS_DATA } from '../data/conditions';
export default function SportsInjury() {
  return <ConditionPage data={CONDITIONS_DATA.sportsInjury} />;
}
